var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorNetwork = function SvgErrorNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 120,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Error_Network_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M110.684 74.192c1.744 1.755 3.439 3.578 5.261 5.255 1.182 1.091 1.201 1.813 0 2.963-7.732 7.41-16.53 13.162-26.567 16.789-25.627 9.272-49.994 6.493-72.889-8.316-3.798-2.457-7.092-5.713-10.629-8.57-1.114-.907-1.153-1.628-.077-2.671 3.73-3.656 7.392-7.38 11.045-11.115.97-.975 1.638-1.101 2.723-.068 7.848 7.41 16.975 12.538 27.497 14.839 20.191 4.426 38.26-.088 53.986-13.669 2.732-2.36 2.693-2.398 5.222.127l4.418 4.445z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Error_Network_svg__b",
    width: 208,
    height: 113,
    x: -48,
    y: -8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M60.81 104.616c-25.07 0-43.704-12.196-48.786-16.94L-47.5 37.492 60.81-8 159.7 32l-48.746 54.999c-16.601 14.229-40.316 17.617-50.142 17.617"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Error_Network_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5,
    cy: 105.5,
    fill: "#D4D9E2",
    opacity: 0.5,
    rx: 41,
    ry: 6.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D8E4",
    d: "M79.49 34.301a12.18 12.18 0 0 1 6.734 3.425c1.95 1.95 3.1 4.4 3.454 6.936l.06.508v.004c.039.423-.103.83-.376 1.14-.284.322-.695.5-1.114.5h-.428a1.21 1.21 0 0 1-1.184-1.118v-.001a9.05 9.05 0 0 0-2.63-5.76 9.03 9.03 0 0 0-5.632-2.622l-.006-.001a1.5 1.5 0 0 1-.926-.442 15 15 0 0 0 2.048-2.569m2.106-10.466c4.46.792 8.73 2.903 12.166 6.34 4.19 4.182 6.412 9.604 6.674 15.094a1.46 1.46 0 0 1-.399 1.09c-.273.285-.66.453-1.059.453H98.8c-.8 0-1.454-.626-1.493-1.418l-.026-.444a19.68 19.68 0 0 0-5.728-12.556 19.64 19.64 0 0 0-9.773-5.33q.02-.379.02-.763c0-.84-.071-1.663-.204-2.466m-.088 5.414a17.46 17.46 0 0 1 8.177 4.398l.3.292a17.54 17.54 0 0 1 5.065 10.887l.03.385v.002c.025.414-.115.811-.394 1.115l-.008.01a1.5 1.5 0 0 1-1.09.467h-.425a1.193 1.193 0 0 1-1.196-1.139l-.045-.646a14.36 14.36 0 0 0-4.156-8.855 14.3 14.3 0 0 0-7.2-3.902c.415-.957.733-1.965.942-3.014"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C9",
    d: "M51.786 122.051H37.65c.036-.613 2.356-39.56 2.356-39.578h9.423c1.017 17.242.66 11.115 2.356 39.578"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACED7",
    d: "M57.44 122.049H31.997c.07-.39 4.243-25.427 4.243-25.443h16.957c1.85 11.071 1.187 7.143 4.243 25.443"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M57.438 122.049c-3.053-18.3-2.39-14.372-4.24-25.443h-8.481v25.443z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D9AE8",
    d: "M72.971 46.588 62.764 56.785l3.667 3.672L76.64 50.26z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C9",
    d: "M75.735 45.844h-21.54v3.077h21.54z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C9",
    d: "M77.272 47.383h-3.077v21.54h3.077z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACED7",
    d: "M56.025 81.059a9.886 9.886 0 0 1-9.894 9.894 9.886 9.886 0 0 1-9.895-9.894 9.886 9.886 0 0 1 9.895-9.895 9.886 9.886 0 0 1 9.894 9.895"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M42.2 80.842c12.925 12.93 33.898 12.93 46.84 0L42.2 34c-12.925 12.93-12.942 33.912 0 46.86z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D8E4",
    d: "m89.04 80.962-23.218-22.93-23.428 23.136c12.952 12.567 33.765 12.498 46.629-.207z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Error_Network_svg__c",
    width: 58,
    height: 57,
    x: 32,
    y: 34,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M42.202 80.842c12.925 12.93 33.898 12.93 46.84 0L42.202 34c-12.925 12.93-12.942 33.912 0 46.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Error_Network_svg__c)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.68,
    cy: 67.182,
    fill: "#B9C2D1",
    opacity: 0.2,
    rx: 36.739,
    ry: 37.058,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "rotate(-44.671 83.68 67.182)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D8E4",
    d: "M80.096 50.613a5.655 5.655 0 1 1-7.997-7.999 5.655 5.655 0 0 1 7.997 8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3,
    cy: 10.3,
    r: 10.3,
    fill: "#F45149",
    transform: "matrix(-1 0 0 1 77.1 16)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.913 22.702a1.57 1.57 0 0 1-1.151-.478 1.57 1.57 0 0 1-.478-1.151q0-.673.478-1.133a1.57 1.57 0 0 1 1.15-.479q.674 0 1.134.479.478.46.478 1.133t-.478 1.15a1.51 1.51 0 0 1-1.133.479m-1.328 11.333v-9.934h2.85v9.934z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.52,
    d: "m113.355 64.047-18.37 3.836M110.768 54.531 94.254 63.45M106.768 45 93.761 58.53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Error_Network_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h120v120H.5z"
  })))));
};
export default SvgErrorNetwork;